import axios from 'axios';
import api from './endpoints';

export default {
  updateProfile(args) {
    return axios.put(api.USER, args);
  },
  changePassword(args) {
    return axios.put(api.CHANGE_PASSWORD, args);
  },
  list(args) {
    return axios.get(api.USERS, {
      params: {
        page: args.page,
        filter: args.filter
      }
    })
      .then((data) => data.data);
  },
  editUser(args) {
    return axios.put(api.resolveEndpoint(api.USERS_EDIT, [args.userId]), args)
      .then((data) => data.data);
  },
  userDetail(args) {
    return axios.get(api.resolveEndpoint(api.USERS_EDIT, [args.userId]), args)
      .then((data) => data.data);
  },
  resetPassword(args) {
    return axios.put(api.resolveEndpoint(api.USERS_RESET_PASSWORD, [args.userId]), args)
      .then((data) => data.data);
  },
  registerToEvent(args) {
    return axios.post(api.resolveEndpoint(api.REGISTER_TO_EVENTS, [args.eventId]), args);
  },
  userEvents(args) {
    return axios.get(api.USER_EVENTS, args);
  },
  editUserEvent(args) {
    return axios.put(api.resolveEndpoint(api.REGISTER_TO_EVENTS, [args.eventId]), args);
  }
};
